<template>
  <react-button 
    v-bind:isReacted="user.meta.isFollowed" 
    v-bind:name="'Trust'" 
    v-bind:icon="'user-check'"
    @toggleOn="followUser()" 
    @toggleOff="unfollowUser()"
  />
</template>

<script>
  import TrustButton from "./TrustButton.ts";

  export default TrustButton;
  
</script>
